import { enableProdMode, isDevMode, mergeApplicationConfig } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { enableAkitaProdMode, persistState } from '@datorama/akita';

import { AppComponent } from './app/app.component';
import { browserConfig } from './app/app.config';

import { logAppVersion, silenceConsole } from './../modules/utilities/log.utils';

// import 'hammerjs';

try {
  // prepare production env
  logAppVersion();

  if (!isDevMode()) {
    enableProdMode();
    enableAkitaProdMode();

    // Silence Console
    silenceConsole();
  }
} catch (error) {
  console.log('[enableProdMode] error', error);
}

try {
  persistState({
    key: 'appStore',
    include: ['favorites', 'collections', 'auth', 'course'],
  });
} catch (error) {
  console.log('[akita persistState] error', error);
  // SecurityError: Failed to read the 'localStorage' property from 'Window': Access is denied for this document.
}

if (isDevMode()) {
  mergeApplicationConfig();
}

bootstrapApplication(AppComponent, browserConfig).catch((error) => console.error('[bootstrapApplication] error', error));
